import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import PageLoadingComponent from './PageLoadingComponent'
import { useSurveyList } from '../../hooks/surveys/queries'
import { useProjectWithErrorHandling } from '../../hooks/projects/useProjectWithErrorHandling'
import { useCurrentProject } from '../../hooks/projects/useCurrentProject'
import { useAllProjectTranscripts } from '../../hooks/transcripts/queries'

const ProjectBody = ({ match, location }) => {
  const history = useHistory();
  const { projectId } = useCurrentProject();

  const { isSuccess: projectLoaded, isFetching: projectRefetching, NotFoundComponent } = useProjectWithErrorHandling(projectId);
  const { data: surveys = [], isSuccess: surveysLoaded, isFetching: surveysRefetching } = useSurveyList(projectId);
  const { data: transcripts = [], isSuccess: transcriptsLoaded, isFetching: transcriptsRefetching } = useAllProjectTranscripts(projectId);

  useEffect(() => {
    // Wait until the project is confirmed (so a 404 renders NotFoundComponent
    // instead of redirecting) and survey/transcript lists have settled.
    if (!projectLoaded || !surveysLoaded || !transcriptsLoaded || projectRefetching || surveysRefetching || transcriptsRefetching) {
      return;
    }

    // Transcripts exist → land on the dashboard. It's the project's hub: it
    // surfaces coverage, "last edited", and what each person is assigned to —
    // a more intuitive entry point than dropping into a single transcript.
    if (transcripts.length > 0) {
      history.replace(`/projects/${projectId}/transcripts`);
      return;
    }

    // No transcripts but surveys exist → first survey
    if (surveys.length > 0) {
      history.replace(`/surveys/${surveys[0].id}`);
      return;
    }

    // Nothing yet → new-transcript upload screen
    if (projectId) {
      history.replace(`/projects/${projectId}/transcripts/new`);
    }
  }, [
    projectLoaded,
    surveysLoaded,
    transcriptsLoaded,
    projectRefetching,
    surveysRefetching,
    transcriptsRefetching,
    transcripts,
    surveys,
    projectId,
    history
  ]);

    // Handle 404 error
  if (NotFoundComponent) {
    return <NotFoundComponent />;
  }

  return <PageLoadingComponent />;
};

export default ProjectBody;